import { render, staticRenderFns } from "./service-safety.vue?vue&type=template&id=0ef49519&scoped=true&"
import script from "./service-safety.vue?vue&type=script&lang=js&"
export * from "./service-safety.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef49519",
  null
  
)

export default component.exports